import { LlmClientShort } from "./LlmClientShort";
import { LlmClientRateLimits } from "./RateLimits";
import { LlmClientCapabilities } from "./Capabilities";
import { LlmClientTokenPricing } from "./TokenPricing";

export class LlmClient extends LlmClientShort {
  public requirements: Record<string, string>;
  public rateLimits: LlmClientRateLimits;
  public capabilities: LlmClientCapabilities;
  public tokenPricing: LlmClientTokenPricing;

  constructor(data: any) {
    super(data);
    this.requirements = data.requirements || {};
    this.rateLimits = new LlmClientRateLimits(data.rateLimits);
    this.capabilities = new LlmClientCapabilities(data.capabilities);
    this.tokenPricing = new LlmClientTokenPricing(data.tokenPricing);
  }
}
